// LoadingSpinner.tsx
import classNames from "classnames";
type LoadingSpinnerSize = "sm" | "md" | "lg";

type LoadingSpinnerProps = {
  size?: LoadingSpinnerSize;
  color?: string;
  label?: string;
  className?: string;
};

export function LoadingSpinner({
  size = "md",
  color = "currentColor",
  label = "Loading",
  className,
}: LoadingSpinnerProps) {
  return (
    <span
      className={classNames(
        "loading-spinner",
        `loading-spinner--${size}`,
        className,
      )}
      style={{ color }}
      role="status"
      aria-label={label}
    />
  );
}
export const PageLoader = ({ message }: { message?: string }) => {
  return (
    <div>
      <div className="modal-overlay"></div>
      <div className="page-loader">
        <LoadingSpinner size="lg" label={message} />
      </div>
    </div>
  );
};
